export default {"src":"/_next/static/image/public/images/menu_right_arrow_black.0d8e0824448c2113cd6a51ce843d0fad.svg","height":14,"width":8};